<template>
    <div>
        <section class="section--alt has-bottom-image">
            <div class="container">
                <div class="row">
                    <div class="col-xs-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
                        <div class="block">
                            <div class="row">
                                <img
                                    class="icon--simtoool col-4"
                                    src="../assets/images/icon_simtool.png"
                                />
                                <div class="col-8">
                                    <h1>{{ $t('account.signup.title') }}</h1>
                                    <p>
                                        {{ $t('account.signup.sub_title') }}
                                    </p>
                                </div>
                            </div>
                            <form class="form--rounded" @submit.prevent="register">
                                <div class="row">
                                    <form-input
                                        class="col-6"
                                        v-model="form"
                                        name="firstname"
                                        :placeholder="$t('account.form.first_name')"
                                    />
                                    <form-input
                                        class="col-6"
                                        v-model="form"
                                        name="lastname"
                                        :placeholder="$t('account.form.last_name')"
                                    />
                                    <form-input
                                        class="col-12"
                                        v-model="form"
                                        name="company"
                                        :placeholder="$t('account.form.company')"
                                    />
                                    <form-input
                                        class="col-6"
                                        v-model="form"
                                        name="postalcode"
                                        :placeholder="$t('account.form.postal_code')"
                                    />
                                    <country-form-input
                                        class="col-6"
                                        v-model="form"
                                        name="country"
                                        :placeholder="$t('account.form.country')"
                                    />
                                    <form-input
                                        class="col-12"
                                        v-model="form"
                                        name="email"
                                        :placeholder="$t('account.form.email')"
                                    />
                                    <form-input
                                        class="col-12"
                                        v-model="form"
                                        name="password"
                                        :placeholder="$t('account.form.password')"
                                        type="password"
                                    />
                                    <form-input
                                        class="col-12"
                                        v-model="form"
                                        name="passwordcheck"
                                        :placeholder="$t('account.form.confirm_password')"
                                        type="password"
                                    />

                                    <p
                                        class="col-12 small"
                                        v-html="
                                            $t('account.form.communication_consent_explanation')
                                        "
                                    ></p>
                                    <checkbox
                                        class="col-12"
                                        id="communication_consent"
                                        name="communication_consent"
                                        v-model="form"
                                    >
                                        {{ $t('account.form.communication_consent_label') }}
                                    </checkbox>
                                    <p
                                        class="col-12 small"
                                        v-t="'account.form.processing_consent_explanation'"
                                    ></p>
                                    <checkbox
                                        class="col-12"
                                        id="process_consent"
                                        name="process_consent"
                                        v-model="form"
                                    >
                                        {{ $t('account.form.processing_consent_label') }}
                                    </checkbox>
                                </div>

                                <input
                                    id="simtool_sign_up"
                                    type="submit"
                                    class="button--primary button--rounded is-full-width"
                                    :value="$t('account.signup.signup')"
                                />
                            </form>
                            <p class="text-center">
                                {{ $t('account.form.already_account') }}
                                <router-link
                                    :to="{ name: 'Login' }"
                                    id="simtool_already_account_login"
                                >
                                    {{ $t('account.login.login') }}
                                </router-link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <img class="section__bottom_image" src="./../assets/images/tecnotion.png" />
        </section>
        <EndSignUpMail />
    </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import EndSignUpMail from '../components/EndSignUpMail.vue';
import FormInput from '../components/FormInput.vue';
import Checkbox from '../components/Checkbox.vue';
import { countries, default as CountryFormInput } from '../components/CountryFormInput.vue';

@Component({
    components: {
        EndSignUpMail,
        FormInput,
        Checkbox,
        CountryFormInput,
    },
})
export default class App extends Vue {
    loading = false;
    form = {
        firstname: { value: null, error: '' },
        lastname: { value: null, error: '' },
        postalcode: { value: null, error: '' },
        country: { value: null, error: '' },
        email: { value: null, error: '' },
        company: { value: null, error: '' },
        password: { value: null, error: '' },
        passwordcheck: { value: null, error: '' },
        process_consent: { value: false, error: '' },
        communication_consent: { value: false, error: '' },
    };

    /* eslint-disable no-useless-escape */
    emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    passwordPattern = /^.{8,}$/;

    async register() {
        if (this.loading || !this.validate()) {
            return;
        }

        try {
            this.loading = true;
            let data = {};
            for (let param in this.form) {
                if (this.form[param].value !== null && this.form[param].value !== undefined)
                    data[param] = this.form[param].value;
            }
            var match = document.cookie.match(new RegExp('hubspotutk' + '=([^;]+)'));
            if (match) data.hubspotutk = match[1];
            else data.hubspotutk = '';

            match = document.cookie.match(new RegExp('__hstc' + '=([^;]+)'));
            if (match) data.__hstc = match[1];
            else data.__hstc = '';

            match = document.cookie.match(new RegExp('__hssc' + '=([^;]+)'));
            if (match) data.__hssc = match[1];
            else data.__hssc = '';

            await Vue.api.post('/signup').send(JSON.stringify(data));
            this.$router.push({ name: 'EmailSend' });
        } catch (e) {
            const errors = await e.json();
            for (let field in errors) {
                if (this.form[field]) {
                    const err =
                        typeof errors[field] === 'string' ? errors[field] : errors[field][0];
                    Vue.set(this.form[field], 'error', err);
                }
            }
        } finally {
            this.loading = false;
        }
    }

    validate() {
        this.reset_form_error();

        if (!this.form.firstname.value) {
            Vue.set(this.form.firstname, 'error', this.$i18n.t('account.errors.not_filled'));
        }

        if (!this.form.lastname.value) {
            Vue.set(this.form.lastname, 'error', this.$i18n.t('account.errors.not_filled'));
        }

        if (!this.form.postalcode.value) {
            Vue.set(this.form.postalcode, 'error', this.$i18n.t('account.errors.not_filled'));
        }

        if (!this.form.country.value || !countries.includes(this.form.country.value)) {
            Vue.set(this.form.country, 'error', this.$i18n.t('account.errors.not_filled'));
        }

        if (!this.form.company.value) {
            Vue.set(this.form.company, 'error', this.$i18n.t('account.errors.not_filled'));
        }

        if (!this.form.email.value) {
            Vue.set(this.form.email, 'error', this.$i18n.t('account.errors.not_filled'));
        } else if (!this.emailPattern.test(this.form.email.value)) {
            Vue.set(this.form.email, 'error', this.$i18n.t('account.errors.not_valid_email'));
        }

        if (!this.form.password.value) {
            Vue.set(this.form.password, 'error', this.$i18n.t('account.errors.not_filled'));
        } else if (!this.passwordPattern.test(this.form.password.value)) {
            Vue.set(this.form.password, 'error', this.$i18n.t('account.errors.not_long_password'));
        }

        if (!this.form.passwordcheck.value) {
            Vue.set(this.form.passwordcheck, 'error', this.$i18n.t('account.errors.not_filled'));
        } else if (this.form.password.value !== this.form.passwordcheck.value) {
            Vue.set(
                this.form.passwordcheck,
                'error',
                this.$i18n.t('account.errors.not_matching_passwords'),
            );
        }

        if (!this.form.process_consent.value) {
            Vue.set(this.form.process_consent, 'error', this.$i18n.t('account.errors.not_filled'));
        }

        return Object.keys(this.form).every(field => !this.form[field].error);
    }

    reset_form_error() {
        Object.keys(this.form).forEach(key => (this.form[key].error = ''));
    }
}
</script>
